// These values have to match with screensizes.scss
export const MOBILE_MAX_WIDTH = 968;
